import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubItem,
} from "./ui/sidebar";
import { NavLink } from "react-router-dom";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "./ui/collapsible";
import { ChevronRight } from "lucide-react";

const items = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: "/icons/dashboard.svg",
    activeIcon: "/icons/dashboard.svg",
  },
  {
    title: "My Wallet",
    url: "/dashboard/wallet",
    icon: "/icons/wallet.svg",
    activeIcon: "/icons/wallet.svg",
  },
  {
    title: "My Cards",
    url: "/dashboard/cards",
    icon: "/icons/card.svg",
    activeIcon: "/icons/card.svg",
  },
  {
    title: "Transactions",
    url: "/dashboard/transactions",
    icon: "/icons/transactions.svg",
    activeIcon: "/icons/transactions.svg",
  },
  {
    title: "Partners",
    url: "/dashboard/partners",
    icon: "/icons/partners.svg",
    activeIcon: "/icons/partners.svg",
  },

  {
    title: "My Account",
    url: "/dashboard/account",
    icon: "/icons/account.svg",
    activeIcon: "/icons/account.svg",
  },
];

const AppSidebar = () => {
  return (
    <Sidebar variant="sidebar">
      <div className="bg-bg-primary flex size-full flex-col overflow-hidden border-r border-r-[#999999]">
        <SidebarHeader>
          <div className="text-primary-100 flex items-center gap-2.5 px-4 py-2">
            <img
              src="/images/full-logo2.svg"
              className="w-40"
              alt="digitwallet logo"
            />
          </div>
        </SidebarHeader>

        <SidebarContent className={"text-white"}>
          <SidebarMenu className={"pl-4"}>
            {items.map((item) => (
              <SidebarMenuItem key={item.title}>
                {item.submenu ? (
                  <Collapsible className="group/collapsible" defaultOpen>
                    <CollapsibleTrigger asChild>
                      <NavLink end={item.url === "/dashboard"} to={item.url}>
                        {({ isActive }) => (
                          <SidebarMenuButton
                            className={`hover:bg-primary-100/15 hover:text-primary-100 relative rounded-r-none px-4 py-5 ${
                              isActive
                                ? "text-primary-100 bg-[linear-gradient(90deg,rgba(180,234,255,0.16)_0%,rgba(22,27,51,0.16)100%)]"
                                : "text-primary-bg"
                            }`}
                            asChild
                          >
                            <div>
                              <img
                                src={isActive ? item.activeIcon : item.icon}
                                className="size-4"
                                alt={item.title}
                              />
                              <span className="leading-6">{item.title}</span>

                              {isActive && (
                                <div className="bg-primary-100 absolute inset-y-0 right-0 w-1 rounded-l" />
                              )}

                              <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                            </div>
                          </SidebarMenuButton>
                        )}
                      </NavLink>
                    </CollapsibleTrigger>
                    <CollapsibleContent>
                      <SidebarMenuSub>
                        {item.submenu.map((subItem) => (
                          <SidebarMenuSubItem key={subItem.title}>
                            <NavLink
                              end={subItem.url === "/dashboard"}
                              to={subItem.url}
                            >
                              {({ isActive }) => (
                                <SidebarMenuButton
                                  className={`hover:bg-primary-100/15 hover:text-primary-100 relative px-4 py-5 ${
                                    isActive
                                      ? "text-primary-100 bg-[linear-gradient(90deg,rgba(233,233,233,0.16)0%,rgba(43,43,43,0.16)100%)]"
                                      : "text-primary-bg"
                                  }`}
                                  asChild
                                >
                                  <div>
                                    <img
                                      src={
                                        isActive ? item.activeIcon : item.icon
                                      }
                                      className="size-4"
                                      alt={subItem.title}
                                    />
                                    <span className="leading-6">
                                      {subItem.title}
                                    </span>
                                  </div>
                                </SidebarMenuButton>
                              )}
                            </NavLink>
                          </SidebarMenuSubItem>
                        ))}
                      </SidebarMenuSub>
                    </CollapsibleContent>
                  </Collapsible>
                ) : (
                  <NavLink end={item.url === "/dashboard"} to={item.url}>
                    {({ isActive }) => (
                      <SidebarMenuButton
                        className={`hover:bg-primary-100/15 hover:text-primary-100 relative h-auto rounded-r-none px-4 ${
                          isActive
                            ? "text-primary-100 bg-[linear-gradient(90deg,rgba(233,233,233,0.16)0%,rgba(43,43,43,0.16)100%)]"
                            : "text-primary-bg"
                        }`}
                        asChild
                      >
                        <div className="flex items-center gap-2.5">
                          <img
                            src={isActive ? item.activeIcon : item.icon}
                            className="size-4"
                            alt={item.title}
                          />
                          <span className="leading-6">{item.title}</span>
                          {isActive && (
                            <div className="bg-primary-100 absolute inset-y-0 right-0 w-1 rounded-l" />
                          )}
                        </div>
                      </SidebarMenuButton>
                    )}
                  </NavLink>
                )}
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarContent>

        <SidebarFooter className="mb-4 text-white"></SidebarFooter>
      </div>
    </Sidebar>
  );
};

export default AppSidebar;
